function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M33.3243 17C33.3243 25.8508 26.2601 33 17.5774 33C8.89477 33 1.83057 25.8508 1.83057 17C1.83057 8.14925 8.89477 1 17.5774 1C26.2601 1 33.3243 8.14925 33.3243 17Z",
  stroke: "#E75C5C",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 17.5625,
  y1: 20,
  x2: 17.5625,
  y2: 9,
  stroke: "#E75C5C",
  strokeWidth: 2
}), React.createElement("line", {
  x1: 17.5625,
  y1: 25,
  x2: 17.5625,
  y2: 22,
  stroke: "#E75C5C",
  strokeWidth: 2
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 33.4937,
  height: 34,
  fill: "white",
  transform: "translate(0.830566)"
})));

var SvgSyncStateFailed = function SvgSyncStateFailed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSyncStateFailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/syncStateFailed.4bcaaa32.svg";
export { ForwardRef as ReactComponent };